import React from "react"
import { Minimize, Fullscreen, Tablet } from "lucide-react"
import { useAppContext } from "../../contexts/AppContext"
import { VirtualKeyboard } from "../ui/VirtualKeyboard"

// Global UI controls (Fullscreen & Keyboard)
export const GlobalControls = () => {
    const { showKeyboard, setShowKeyboard, isFullscreen, toggleFullscreen, keyboardEnabled, toggleKeyboardEnabled } =
        useAppContext()

    return (
        <>
            {/* Bottom right action buttons */}
            <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-[999]">
                <button
                    onClick={toggleFullscreen}
                    className="bg-neutral-200 dark:bg-neutral-700 text-neutral-950 dark:text-neutral-50 p-3 rounded-full shadow-lg hover:bg-neutral-300 dark:hover:bg-neutral-800 transition-colors"
                    aria-label="Toggle fullscreen"
                    title={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
                >
                    {isFullscreen ? <Minimize size={24} /> : <Fullscreen size={24} />}
                </button>

                <button
                    onClick={() => {
                        // Toggle keyboard enabled state
                        toggleKeyboardEnabled()

                        // If turning keyboard mode on, also show keyboard if not visible
                        if (!keyboardEnabled) {
                            setShowKeyboard(true)
                        } else {
                            // If turning keyboard mode off, hide keyboard
                            setShowKeyboard(false)
                        }
                    }}
                    className={`${
                        keyboardEnabled
                            ? "bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-700 dark:hover:bg-emerald-800 text-white"
                            : "bg-neutral-200 dark:bg-neutral-700  hover:bg-neutral-300 dark:hover:bg-neutral-800"
                    } text-neutral-950 dark:text-neutral-50 p-3 rounded-full shadow-lg transition-colors`}
                    aria-label="Toggle keyboard"
                    title={keyboardEnabled ? "Tablet Mode enabled" : "Tablet Mode disabled"}
                >
                    <Tablet size={24} />
                </button>
            </div>

            {/* Global keyboard - always positioned at bottom of viewport */}
            <div className="z-[998]">
                <VirtualKeyboard />
            </div>
        </>
    )
}